import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-one">
      <div
        className="footer-one__bg"
      // style={{ backgroundImage: "url(/assets/images/suhani/bg1.webp)" }}
      ></div>

      <div className="footer-one__top">
        <div className="container">
          <div className="row footer-new">
            {/* Logo Section */}
            <div
              className="footer-center mb-50 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="footer-widget__about">
                <div className="footer-widget__about-logo">
                  <a href="#home">
                    <img
                      src="/assets/images/suhani/whitelogo.png"
                      alt="Suhani Builders Logo"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Links Section */}
            <div
              className="footer-center mb-50 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="footer-widget__links">
                <h3 className="footer-widget__title">Links</h3>
                <ul className="footer-widget__links-list list-unstyled footer-links">
                  <li><a href="#home">Home</a></li>
                  <li><a href="#aboutus">About Us</a></li>
                  <li><a href="#gallery">Gallery</a></li>
                  <li><a href="#testimonial">Testimonials</a></li>
                  <li><a href="#ourteam">Our Team</a></li>
                  <li><a href="#contactus">Contact Us</a></li>
                </ul>
                <br />
     <ul className="footer-widget__links-list list-unstyled footer-links">
  <li>
    <a href="/privacy-policy.html">Privacy Policy</a>
  </li>
  <li>
    <a href="/terms-conditions.html">Terms and Conditions</a>
  </li>
</ul>

              </div>
            </div>

            {/* Social Media Section */}
            <div
              className="footer-center wow fadeInUp"
              data-wow-delay="0.9s"
            >
              <div className="footer-widget__social-links">
                <ul className="footer-widget__social-links-list list-unstyled clearfix footer-socials">
                  <li>
                    <a
                      href="https://www.facebook.com/suhanibuilder"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      aria-label="Instagram"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-one__bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="footer-one__bottom-inner">
                <div className="footer-one__bottom-text text-center">
                  <p>&copy; 2024 Suhani.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="footer-one__bottom-inner">
                <div className="footer-one__bottom-text text-center">
                  <p>
                    Developed By{" "}
                    <a
                      href="https://www.absoluteweb.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#aeb2c2' }}
                    >
                      AbsoluteWeb
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
